import { Trash2 } from "lucide-react";

/**
 * Small trash-icon button with confirm() dialog + async onDelete handler.
 */
export function DeleteButton({ onDelete, label = "Delete", confirmText, testid, className = "" }) {
  const handle = async (e) => {
    e.stopPropagation();
    if (!window.confirm(confirmText || `${label} — are you sure?`)) return;
    await onDelete();
  };
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={handle}
      title={label}
      className={`inline-flex items-center gap-1 rounded-md border border-border/70 px-2 py-1 text-xs text-muted-foreground hover:border-destructive/60 hover:text-destructive ${className}`}
    >
      <Trash2 className="h-3.5 w-3.5" />
    </button>
  );
}
